module.exports = __webpack_public_path__ + "static/media/embed-analytic.53cafacc.svg";